import { Grid } from '@mui/material';
import React, { useEffect } from 'react';

import { ParameterNoUIFormFragmentProps } from './ParameterNoUIFormFragment.props';
import { Typography, TypographyFontWeightProps, TypographyVariantProps } from '../../../../../../components/atoms/Typography';
import { getSetParameterNoUIFormSelectedValue } from '../../../../../../utils/services';

export const ParameterNoUIFormFragment: React.FC<ParameterNoUIFormFragmentProps> = ({
  preSelectedData,
  onChange,
  value
}) => {

  useEffect(() => {
    let checkValue: NodeJS.Timeout;
    if (!value) {
      checkValue = setInterval(() => {
        preSelectedData && onChange(getSetParameterNoUIFormSelectedValue(preSelectedData));
      }, 500);
    }
    return () => {
      clearInterval(checkValue);
    };
  }, [preSelectedData,value]);

  return (
    <Grid container marginTop={1} marginBottom={1}>
      <Typography
        variant={TypographyVariantProps.Body1}
        fontWeight={TypographyFontWeightProps.Bold}
      >
        {`Set parameter ${preSelectedData?.parameterType} interaction in-progress`}
      </Typography>
    </Grid>
  );
};